import React, { useState, useEffect } from 'react';
import AddToCart from "../../../component/Global/Cart/AddToCart";
import { useDispatch, useSelector } from "react-redux";
import QuantityPicker from "../../../component/Global/Cart/QuantityPicker";
import CommonCart from "src/component/Global/Cart/Common";
import store from "../../../storeWire";
import Product from '@system/config/product';
import { system_notification } from "../../../store/slice/system";
import DisplayQtyMinQtyMult from "../../../component/Product/DisplayQtyMinQtyMult";
import PriceTable from "../../../component/Global/Cart/PriceTable";
import { useAxiosIndicatorCheck } from "../../../store/hook/useAxiosIndicatorCheck";
import liveAuth from 'src/helper/liveAuth';
import System from 'src/helper/system';
import { NonLoginSignInButton } from 'src/reusable/global';
import { useCartStore } from "../../../hooks/cart";
import useCheckAuthPermissions from 'src/hooks/component/useCheckAuthPermissions';
import { Tooltip } from 'src/component/Tooltip';
import RoleAndPermission from 'src/helper/RoleAndPermission';
import { isArray, isNumber } from "underscore";
import Helper from 'src/support/Helper';
import $ from "jquery";
import { applyFilterByMainKeyAndSlug } from "../../../store/slice/ProductListingFilterApplied";
import FadeInOut from "../../../component/FadeInOut";
import CartCommon from "../../../component/Global/Cart/Common";
import ProductDetailAd from './ProductDetailAd';
import { useProductPricingStore } from 'src/hooks/productPricing';
import { useProductInventoryStore } from 'src/hooks/productInventory';
import StripPriceLoader from 'src/component/StripPriceLoader';
import { useQuoteDetailStore } from 'src/hooks/quote-detail';
import Constants from 'src/support/Constants';
import { NotifyMe } from "../../../component/Global/Product/NotifyMe";
import RefreshStockButton from 'src/pages/ProductListing/RefreshStockButton';
import FactoryLeadTimeDisplay from 'src/component/Product/FactoryLeadTimeDisplay';
import ProductInventoryAPICall from 'src/service/ProductInventoryAPICall';
import { useProductStore } from 'src/hooks/product';

const ProductDetailBuyBox = (props) => {
    const [__check] = useAxiosIndicatorCheck();
    const [_check_p] = useCheckAuthPermissions();
    const dispatch = useDispatch();
    const [isFirstLoad, setIsFirstLoad] = useState(true)
    // const productDetail = useSelector((state) => state.entities.model_ProductDetail.setProductDetail.data)
    const [{ productDetail }] = useProductStore();
    const [{ CART_PRICE_BEFORE_TO_SEND_SERVER, CART_BEFORE_TO_SEND_SERVER }, { get_updated_qty }, { }] = useCartStore();
    const [{ approved_quote_list }, { }, { }] = useQuoteDetailStore();
    const [isDisplay, setDisplay] = useState(true);
    const [expandBox, setExpandBox] = useState(false);
    const expandVal = React.useRef(expandBox);
    const [{ pricingList }, { }, { }] = useProductPricingStore();
    const { setParentClass } = props;
    const pricing = pricingList
    const orderBlock = System.getOrderBlockCreditRiskFlagBySpeedboat().isOrderBlock;
    const [approvedQuoteList, setApprovedQuoteList] = useState([])
    const [, { get_inventory_by_id }] = useProductInventoryStore();
    const userType = System.avUserInfoData.userType
    const { siteUser: { CORE } } = Constants;

    useEffect(() => {
        if (approved_quote_list?.length > 0) {
            setApprovedQuoteList(approved_quote_list)
        }
    }, [approved_quote_list])


    useEffect(() => {
        let defaultPosition = 0;
        const BUY_BOX_FIXED_CLASSNAME = "fixed-buy-box";
        // local
        // const headerHeight = document?.getElementsByTagName("header") ? document?.getElementsByTagName("header")[0]?.clientHeight : 65;
        //sbx
        let headerHeight = document?.getElementsByClassName("navbar navbar-default white") ? document?.getElementsByClassName("navbar-default")[0]?.clientHeight : 65;

        // Admin Toolbar header height adjustment
        const adminToolBarHeight = document?.getElementsByClassName("wpToolbarActionBar wpToolbarCommon")?.length > 0 ? document?.getElementsByClassName("wpToolbarActionBar wpToolbarCommon")[0]?.clientHeight : 0;

        if (adminToolBarHeight > 0) {
            headerHeight = headerHeight + adminToolBarHeight;
        }

        const scrollEvent = e => {
            const ele = document.getElementById("stock-box-pdp");
            if (defaultPosition === 0) {
                defaultPosition = ele.getBoundingClientRect().y;
            }
            const pyOffset = window.pageYOffset;
            if (pyOffset + headerHeight > defaultPosition + ele.clientHeight) {
                // add class to see fixed box
                if (setParentClass) {
                    setParentClass(BUY_BOX_FIXED_CLASSNAME);
                    if (expandVal.current && isDisplay) {
                        setDisplay(false);
                    }
                }
            } else {
                // remove class to see fixed box  
                setDisplay(true);
                if (setParentClass) {
                    setParentClass('');
                }
            }
        }
        document.addEventListener("scroll", scrollEvent);
        return () => {
            document.removeEventListener("scroll", scrollEvent)
        }
    }, [])

    useEffect(() => {
        expandVal.current = expandBox;
    }, [expandBox]);

    useEffect(() => {
        if (!__check(['PRODUCT_DETAIL_API_CALL_ON_PAGE_LOADING']).status && isFirstLoad) {
            setIsFirstLoad(false)
        }
    }, [__check(['PRODUCT_DETAIL_API_CALL_ON_PAGE_LOADING']).status])

    const getInventory = () => {
        return get_inventory_by_id(productDetail?.value?.ERPPartNumber)
    };

    const getPricing = () => {
        if (productDetail.value.ERPPartNumberModified) {
            return pricing[productDetail.value.ERPMFRPartNumber + '-'];
        }
        if (pricing[productDetail.value.ERPMFRPartNumber + '-' + productDetail.value.ERPPartNumber] !== undefined) {
            return pricing[productDetail.value.ERPMFRPartNumber + '-' + productDetail.value.ERPPartNumber];
        }
        return [];
    };

    const authLoggedIn = () => {
        return liveAuth.check();
    };

    const openContactUsPopup = () => {
        store.dispatch(system_notification({
            name: 'ContactUsPopup',
            data: { restrict: true, order_block: orderBlock },
        }));
    };

    const openQuoteBox = () => {
        if (_check_p('PDT_CLICK_TO_QUOTE').status === false) {
            openContactUsPopup();
            return false;
        }
        !authLoggedIn() ? System.popup('GuestPopupActionButton', {
            title: 'Request A Quote',
            body: 'Sign in to request a quote.'
        }) :
            store.dispatch(system_notification({
                name: 'QuotePopup',
                data: {
                    single_product: productDetail.value,
                    addFrom: 'PDP'
                },
            }));
    }

    const openAddToBOM = (e) => {
        if (_check_p('PDT_ADD_TO_BOM').status === false) {
            openContactUsPopup();
            return false;
        }
        const _product = get_updated_qty(e, CART_BEFORE_TO_SEND_SERVER);
        store.dispatch(system_notification({
            name: 'AddToBOMPopup',
            data: {
                single_product: _product,
                addFrom: 'PDP'
            }
        }));
    };

    const pricing_single_display = productDetail?.value?.ItemNumber &&
        CART_BEFORE_TO_SEND_SERVER[productDetail.value.ItemNumber] &&
        CART_BEFORE_TO_SEND_SERVER[productDetail.value.ItemNumber].quantityAddToCart !== undefined ? new CommonCart().getCurrentPriceByQuantityAndPriceArray(getPricing(), CART_BEFORE_TO_SEND_SERVER[productDetail.value.ItemNumber].quantityAddToCart) : {};

    const displayPricingBasedOnSingleProduct = (v) => {
        if (!new CartCommon().getDisplayStatusOfPricingTable(getInventory(v.ERPPartNumber), v)) {
            return false;
        }
        let p;
        if (CART_BEFORE_TO_SEND_SERVER[v.ItemNumber] === undefined) {
            p = Number(parseFloat(new CommonCart().getCurrentPriceByQuantityAndPriceArray(getPricing(v.ERPMFRPartNumber, v.ERPPartNumber), v.QtyMult).marketPrice * v.QtyMin).toFixed(3));
        } else {
            p = Number(parseFloat(new CommonCart().getCurrentPriceByQuantityAndPriceArray(getPricing(v.ERPMFRPartNumber, v.ERPPartNumber), CART_BEFORE_TO_SEND_SERVER[v.ItemNumber].quantityAddToCart).marketPrice * CART_BEFORE_TO_SEND_SERVER[v.ItemNumber].quantityAddToCart).toFixed(3));
        }
        if ((isNumber(p) && !isNaN(p)) === false) {
            return false;
        }
        return (
            <>
                {(isNumber(p) && !isNaN(p)) ? new Intl.NumberFormat(Helper.getCurrencyFormat(window.mct), {
                    style: 'currency',
                    currency: window.mct
                }).format(p).replace(/\s/g, "") : ''}
            </>
        );
    };

    const isGuestFullRights = () => {
        return (_check_p('PDG_ADD_TO_CART').status &&
            _check_p('PDG_ADD_TO_BOM').status &&
            _check_p('PDG_CLICK_TO_QUOTE').status);
    }

    const displayMarketPrice = (pricing_single_display) => {
        if (pricing_single_display.marketPrice && pricing_single_display.marketPrice) {
            return Helper.getFormatNumber(Number(pricing_single_display.marketPrice), window.mct, window.mcs, 5, true, false);
        }
        return false;
    }

    const dispatchAllAttributeSelection = () => {
        toggleAllSelection();
        window.location.href = Product.getProductListingPageRouteURL() + '?' + $.param({
            go: System.getParams().go,
            appendFacadeOptions: 'yes'
        });
    }
    const applyFilterByMainKeyAndSlugInternal = (element) => {
        if (productDetail.value.categoryListing &&
            isArray(productDetail.value.categoryListing) &&
            productDetail.value.categoryListing.length > 0) {
            productDetail.value.categoryListing.map((v, i) => {
                let k = {
                    key: "Categories",
                    main_label: "Categories",
                    value: v.value
                };
                if (v.level !== undefined) {
                    k.hidden_payload = {
                        Level: v.level
                    };
                }
                dispatch(applyFilterByMainKeyAndSlug(k));
            });
        }
        dispatch(applyFilterByMainKeyAndSlug({
            key: System.anythingToCamel(element.ATTRNAME),
            main_label: element.ATTRNAME,
            value: element.ATTRVAL,
        }))
    }

    const toggleAllSelection = () => {
        if (productDetail.value.Attributes.length) {
            productDetail.value.Attributes.map((v) => {
                applyFilterByMainKeyAndSlugInternal(v);
            });
        }
    };

    const isAuthAccountLess = () => {
        return _check_p('PD_ADD_TO_BOM').status === true
    }

    const onQuoteChange = (ele) => {
        let quoteArr = ele.includes('||') ? ele.split('||') : ele;
        if (ele && quoteArr.length > 0 && approvedQuoteList && approvedQuoteList.length > 0 && approvedQuoteList.filter(x => x.quoteNumber === quoteArr[0]).length > 0) {
            System.popup('ApprovedQuoteInfoPopup', {
                quoteNumber: quoteArr[0],
                quoteLineNumber: quoteArr[1]
            })
        }
    }

    const redirectToRoHSInfo = () => {
        window.open(System.getRoHSURL(), '_blank');
    }

    return (
        <>
            {productDetail.value &&
                <>
                    <FadeInOut show={true} duration={500} className={isDisplay ? 'stock-box' : 'stock-box stock-box-small'}>

                        {__check(['PRODUCT_DETAIL_API_CALL_ON_PAGE_LOADING']).status && isFirstLoad ?
                            <StripPriceLoader /> :
                            <>
                                <div className={isDisplay ? 'stockbox-show' : 'stockbox-hide'}>
                                    {((getInventory()?.qas < 1) && (productDetail.value.Attributes.length > 0 || authLoggedIn())) &&
                                        <div className="stock-outofbox text-black">
                                            {__check(['PRODUCT_INVENTORY_API_CALL', 'PRODUCT_PRICING_API_CALL']).status === false && productDetail.value.Attributes.length > 0 &&
                                                <div>
                                                    <b className="me-3">Out of stock part</b>
                                                    <a href={void (0)} onClick={() => {
                                                        dispatchAllAttributeSelection()
                                                    }} className="ext-black"><u>View similar parts</u></a>
                                                </div>
                                            }
                                            {authLoggedIn() && userType === CORE && <NotifyMe single_product={productDetail?.value} fetch_stock_alert_products_details={props.fetch_stock_alert_products_details} />}
                                        </div>}
                                    <div className="stock-price-title">
                                        <div className="text-darkgreen stock-price-title-text">
                                            <span
                                                className="me-1">In Stock: {getInventory().qas ? getInventory().qas : 0}
                                                {__check(['PRODUCT_INVENTORY_API_CALL', 'CART_API_CALL', 'PRODUCT_PRICING_API_CALL', 'ALERT_API_CALL'], { inline: true }).status &&
                                                    <></>
                                                }
                                                {__check(['PRODUCT_INVENTORY_API_CALL', 'CART_API_CALL', 'PRODUCT_PRICING_API_CALL', 'ALERT_API_CALL'], { inline: true }).status === false &&
                                                    <>
                                                        &nbsp;<i className="fa fa-check-circle" />
                                                    </>
                                                }
                                            </span>
                                        </div>

                                        <div className="refresh-link">
                                            <RefreshStockButton
                                                fetchInventoryFromServer={async () => {
                                                    if (productDetail?.value) {
                                                        await new ProductInventoryAPICall().getInventory([
                                                            {
                                                                sboat: productDetail.value.Sboat,
                                                                ERPManufacturerCode: productDetail.value.ERPManufacturerCode,
                                                                ERPPartNumber: productDetail.value.ERPPartNumber
                                                            }
                                                        ], true)
                                                    }
                                                }}
                                            />
                                        </div>
                                    </div>

                                    <div className="">
                                        <div className="factory-lead-title text-black-stone factory-lead-title-text">
                                            <FactoryLeadTimeDisplay
                                                single_product={productDetail.value}
                                                single_product_inventory={getInventory()}
                                                from="PDP"
                                            />
                                        </div>
                                    </div>
                                </div>
                                {authLoggedIn() && isGuestFullRights() &&
                                    <>
                                        <div className={isDisplay ? 'stockbox-show' : 'stockbox-hide'}>
                                            <div className={orderBlock ? "stockbox-hide" : "stockbox-seprator"} />
                                            <div className="stock-price-box">
                                                <div className={orderBlock ? "stockbox-hide" : "bs5 row g-4 flex-nowrap"}>
                                                    <div className="col price-left">
                                                        <div
                                                            className={"mb-2 "}>
                                                            {isArray(getPricing()) && getPricing().length > 0 &&
                                                                <b>Price per unit:</b>
                                                            }
                                                        </div>
                                                        <div>
                                                            <div className="mb-1"><b>Quantity:</b></div>
                                                            <div className="text-black-stone">
                                                                <DisplayQtyMinQtyMult
                                                                    single_product={productDetail.value} />
                                                            </div>
                                                        </div>
                                                        {productDetail?.value && !productDetail.value.ObsoleteFlag &&
                                                            <div
                                                                className={"mt-3"}>
                                                                <span>
                                                                    {_check_p('PDTG_CLICK_TO_QUOTE').status === false ?
                                                                        <Tooltip
                                                                            position={'bottom center'}
                                                                            opener={() => (
                                                                                <a className="text-blue unauthorize-link">Click
                                                                                    To Quote</a>
                                                                            )}
                                                                            content={() => (
                                                                                <>
                                                                                    <div
                                                                                        dangerouslySetInnerHTML={{ __html: RoleAndPermission.guestErrorTooltip() }}>
                                                                                    </div>
                                                                                </>
                                                                            )}
                                                                        /> :
                                                                        <>
                                                                            {isArray(getPricing()) && getPricing().length > 0 &&
                                                                                <a className="text-blue"
                                                                                    onClick={() => openQuoteBox()}>Click To Quote</a>
                                                                            }
                                                                        </>

                                                                    }
                                                                </span>
                                                            </div>
                                                        }
                                                        <div className="mt-3">
                                                            {approvedQuoteList && approvedQuoteList?.length > 1 &&
                                                                <select className="form-control" onChange={({ target: { value } }) => onQuoteChange(value)}>
                                                                    <option value="">Approved Quotes</option>
                                                                    {approvedQuoteList.map((v, i) => (
                                                                        <option key={i} value={v.quoteNumber + '||' + v?.quoteLineNumber}>{v.quoteNumber}-{v?.quoteLineNumber}</option>
                                                                    ))}
                                                                </select>
                                                            }
                                                            {approvedQuoteList && approvedQuoteList?.length === 1 &&
                                                                <>
                                                                    <b>Approved Quote:</b> <br />
                                                                    <a href={void (0)} onClick={() => onQuoteChange(approvedQuoteList[0]?.quoteNumber + '||' + approvedQuoteList[0]?.quoteLineNumber)} target='_blank'> {approvedQuoteList[0]?.quoteNumber}-{approvedQuoteList[0]?.quoteLineNumber} </a>
                                                                </>

                                                            }
                                                        </div>
                                                    </div>
                                                    <div className="col-6 ps-0">
                                                        {CART_PRICE_BEFORE_TO_SEND_SERVER[productDetail.value.ItemNumber] !== undefined &&
                                                            displayPricingBasedOnSingleProduct(productDetail.value) !== false &&
                                                            <div className="price dense-hide mb-2">
                                                                {window.mct === window.mcs &&
                                                                    <strong>
                                                                        {window.mct} :
                                                                    </strong>
                                                                }
                                                                {window.mct !== window.mcs &&
                                                                    <strong>
                                                                        {window.mct} <span>{window.mcs}</span>:
                                                                    </strong>
                                                                }
                                                                <div
                                                                    className="pull-right font-bold">
                                                                    {CART_PRICE_BEFORE_TO_SEND_SERVER[productDetail.value.ItemNumber] !== undefined &&
                                                                        CART_PRICE_BEFORE_TO_SEND_SERVER[productDetail.value.ItemNumber].unitPrice !== undefined &&
                                                                        <>
                                                                            {pricing_single_display && pricing_single_display.marketPrice !== undefined ? displayMarketPrice(pricing_single_display) : ''}
                                                                        </>
                                                                    }
                                                                </div>
                                                            </div>
                                                        }
                                                        <div className="d-flex">
                                                            <QuantityPicker
                                                                single_product_pricing_list={getPricing()}
                                                                single_product={productDetail.value}
                                                                single_product_inventory={getInventory()}

                                                            />
                                                        </div>
                                                        <PriceTable
                                                            auto_select_from_cart_data={false}
                                                            linesToDisplay={3}
                                                            single_product={productDetail.value}
                                                            single_product_inventory={getInventory()}
                                                            single_product_pricing_list={getPricing()} />
                                                    </div>
                                                </div>
                                                <div className="stockbox-seprator" />
                                                <div className="stock-subtotal-wrapper">
                                                    {(CART_PRICE_BEFORE_TO_SEND_SERVER[productDetail.value.ItemNumber] !== undefined &&
                                                        CART_PRICE_BEFORE_TO_SEND_SERVER[productDetail.value.ItemNumber].unitPrice !== undefined &&
                                                        CART_BEFORE_TO_SEND_SERVER[productDetail.value.ItemNumber].quantityAddToCart !== undefined) === true &&
                                                        displayPricingBasedOnSingleProduct(productDetail.value) !== false &&
                                                        <>
                                                            <div className="stock-subtotal-header">
                                                                <div
                                                                    className="stock-subtotal-title">SubTotal:
                                                                </div>
                                                                <div
                                                                    className="stock-subtotal-desc">
                                                                    {isNumber(pricing_single_display.marketPrice * CART_BEFORE_TO_SEND_SERVER[productDetail.value.ItemNumber].quantityAddToCart) ? Helper.getFormatNumber(
                                                                        Number(pricing_single_display.marketPrice * CART_BEFORE_TO_SEND_SERVER[productDetail.value.ItemNumber].quantityAddToCart),
                                                                        window.mct,
                                                                        window.mcs) : ''}</div>
                                                            </div>
                                                        </>
                                                    }
                                                    <div className="stock-subtotal-actions">
                                                        <div className="bs5 row g-3">
                                                            <div className="col-6">
                                                                <button className="bs5 btn btn-secondary btn-sm w-100"
                                                                    onClick={() => openAddToBOM(productDetail.value)}>ADD TO BOM
                                                                </button>
                                                            </div>
                                                            <div className="col-6">
                                                                <AddToCart
                                                                    product_detail={true}
                                                                    initialDispatchOnFirstLoad={true}
                                                                    single_product_pricing_list={getPricing()}
                                                                    single_product_inventory={getInventory()}
                                                                    single_product={productDetail.value}
                                                                    isFrom="PDP" />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className={isDisplay ? 'sticky-footer' : 'sticky-footer sticky-arrow-down'}>
                                            <button className={isDisplay ? "expand" : "expand"} onClick={() => { setDisplay(prev => !prev); setExpandBox((prevState) => !prevState) }}>
                                                <span className="fa sticky_footer_span fa-angle-double-up"></span>
                                            </button>
                                        </div>
                                    </>
                                }
                                {
                                    isGuestFullRights() || isAuthAccountLess() &&
                                    <div className="stock-subtotal-actions">
                                        <div className="bs5 row g-3">
                                            <div className="col-12 text-center py-3">
                                                <button className="bs5 btn btn-secondary w295"
                                                    onClick={() => openAddToBOM(productDetail.value)}>ADD TO BOM
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                }
                                {(!authLoggedIn() || (authLoggedIn() && isGuestFullRights() === false || !isAuthAccountLess())) &&
                                    <NonLoginSignInButton isAuthAccLess={authLoggedIn() && isGuestFullRights() === false} />
                                }

                            </>
                        }
                    </FadeInOut>

                    <div className="rohs-banner cursor-pointer mb-3" onClick={redirectToRoHSInfo}>
                        REACH, RoHS and
                        Conflict Minerals Information

                        <a className="bs5 btn btn-secondary mt-3 btn-sm w-100" style={{ textTransform: "none" }}>CLICK HERE TO VIEW RoHS INFO</a>
                    </div>
                    {!authLoggedIn() &&
                        <ProductDetailAd />
                    }
                </>
            }
        </>
    );
}

export default ProductDetailBuyBox;